module.exports = __webpack_public_path__ + "static/media/settings.63bd21fa.svg";